import React from "react";
import "./multipleSelectCards.scss";

export interface CardInterface {
   title: string;
   value: string;
   image: string;
}

export interface CardUIInterface {
   card: CardInterface;
   isSelected: boolean;
   index: number;
   disabled?: boolean;
   onClick?: any;
   onlyShowSelected?: boolean;
}

interface MultipleSelectCardsProps {
   limit?: number;
   selected: Array<String>;
   setSelected: any;
   cards: Array<CardInterface>;
   disabled?: boolean;
   onlyShowSelected?: boolean;
}

const Card = (props: CardUIInterface) => {

   const { card, disabled = false, isSelected, onClick, index, onlyShowSelected = false } = props;

   return (
      <div
         className={`o-multiple-select-cards-container__card ${isSelected ? "--selected" : ""
            } ${(onlyShowSelected || disabled) ? '' : '--available'}`}
         key={card.value}
         id={card.value}
         onClick={(onlyShowSelected || disabled) || !onClick ? (() => { }) : onClick}
      >
         <div
            className={`o-multiple-select-cards-container__card__number ${isSelected ? "--selected-number" : ""
               }`}
         >
            {isSelected
               ? index
               : ""}
         </div>
         <img
            src={card.image}
            alt={card.title}
            className="o-multiple-select-cards-container__card__image"
         />
         <section className="o-multiple-select-cards-container__card__title">
            <h3>{card.title}</h3>
         </section>
      </div>
   );
}

const MultipleSelectCards = (props: MultipleSelectCardsProps) => {
   //const [selected, setSelected] = useState<Array<String>>([]);
   const { selected, setSelected, cards, disabled = false, onlyShowSelected = false } = props;

   const handleClick = (e: any) => {
      e.persist();
      const id = e.currentTarget.id;
      const newSelected = [...selected];
      const idx = newSelected.indexOf(id);
      if (idx < 0) {
         if (props?.limit && selected.length >= props?.limit) {
            return;
         }
         newSelected.push(id);
      } else {
         newSelected.splice(idx, 1);
      }
      setSelected(newSelected);
   };

   return (
      <div
         className="o-multiple-select-cards-container"
         style={{ gridTemplateColumns: `${onlyShowSelected ? 'repeat(' + selected.length + ', minmax(100px, 250px))' : ""}` }}
      >
         {!onlyShowSelected ? cards.map((card) => (
            <div className="o-multiple-select-cards-container__card-container" key={card.title}>
               <Card
                  card={card}
                  onClick={handleClick}
                  isSelected={selected.includes(card.value)}
                  index={selected.indexOf(card.value) + 1}
                  disabled={disabled}
                  key={card.value}
               />
            </div>
         )) : selected.length ?
            selected.map((id) => {

               const displayCard = cards.filter((card) => card.value == id)[0];
               return (
                  <div
                     className={`o-multiple-select-cards-container__card-container`}
                     key={displayCard.title}
                  >
                     <Card
                        card={displayCard}
                        isSelected={true}
                        index={selected.indexOf(displayCard.value) + 1}
                        onlyShowSelected={true}
                        disabled={true}
                     />
                  </div>
               );
            })
            : null}
      </div>
   );
};

export default MultipleSelectCards;
